/**
 * DenialDialog - Insurance denial reason dialog
 * Extracted from ReferralsPage to reduce file size
 */
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";

const COMMON_DENIAL_REASONS = [
  "Not covered by insurance",
  "Pre-authorization denied",
  "Out of network",
  "Services not medically necessary",
  "Coverage expired"
];

export function DenialDialog({
  open,
  onOpenChange,
  denialReason,
  setDenialReason,
  moveToNonAdmit,
  setMoveToNonAdmit,
  onSubmit,
  onCancel,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Insurance Denial Reason</DialogTitle>
          <DialogDescription>
            Please provide a reason for denying insurance coverage.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="denial-reason">Reason for Denial</Label>
            <Textarea
              id="denial-reason"
              placeholder="Enter the reason for denial..."
              value={denialReason}
              onChange={(e) => setDenialReason(e.target.value)}
              rows={3}
              data-testid="denial-reason-input"
            />
          </div>
          <div className="space-y-2">
            <Label className="text-sm text-slate-500">Common Reasons</Label>
            <div className="flex flex-wrap gap-2">
              {COMMON_DENIAL_REASONS.map((reason) => (
                <Button
                  key={reason}
                  type="button"
                  variant="outline"
                  size="sm"
                  className="text-xs"
                  onClick={() => setDenialReason(reason)}
                >
                  {reason}
                </Button>
              ))}
            </div>
          </div>
          
          {/* Move to Non-Admit option */}
          <div className="flex items-center space-x-2 p-3 bg-orange-50 rounded-lg border border-orange-200">
            <Checkbox
              id="move-to-non-admit"
              checked={moveToNonAdmit}
              onCheckedChange={setMoveToNonAdmit}
              data-testid="move-to-non-admit-checkbox"
            />
            <div className="flex-1">
              <label
                htmlFor="move-to-non-admit"
                className="text-sm font-medium text-orange-800 cursor-pointer"
              >
                Move file to Non-Admit
              </label>
              <p className="text-xs text-orange-600">
                This will close the referral and mark it as non-admitted due to insurance denial
              </p>
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            type="button"
            className="bg-red-600 hover:bg-red-700"
            onClick={onSubmit}
            data-testid="confirm-deny-btn"
          >
            Confirm Denial
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
